module.exports = __webpack_public_path__ + "static/media/official_qrcode.fa39221e.jpg";